export enum CmsVisibility {
  AUTHOR = 'author',
  INVISIBLE = 'invisible',
  PUBLIC = 'public'
}
